import { render } from "./MensMagazineProfile.vue?vue&type=template&id=6365c7be&scoped=true&ts=true"
import script from "./MensMagazineProfile.vue?vue&type=script&lang=ts"
export * from "./MensMagazineProfile.vue?vue&type=script&lang=ts"

import "./MensMagazineProfile.vue?vue&type=style&index=0&id=6365c7be&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6365c7be"]])

export default __exports__